export { CaretakerCard } from './CaretakerCard'



// WEBPACK FOOTER //
// ./src/views/FullMapCaretakers/components/CaretakerCard/index.ts